<input pInputText
       id="number"
       #text="ngModel"
       type="number"
       [required]="column.validation?.isRequired === true"
       [maxlength]="column.validation?.maxLength || null"
       [(ngModel)]="record[column.field]" />

<div *ngIf="text.invalid && (text.dirty || text.touched)"
     class="alert">
  <div *ngIf="text.errors?.['required']">
    Required.
  </div>
</div>
